$(document).on('closing', '.biotech_modal--stores', () => {
    window.isStoreModalOpen = false;
    $('#molin-chat-custom-button').show();
});

const pssProductStoreStockButtonListener = (initMapCoordinatesLat, initMapCoordinatesLng) => {
    document.getElementById('storeStockButton').addEventListener('click', function () {
        if (window.Molin && typeof window.Molin.closeChat === 'function') {
            window.isStoreModalOpen = true;
            $('#molin-chat-custom-button').hide();
            window.Molin.closeChat()
        }
        if (storeList.length === 0 || pssLastFetchTime < (Date.now() - (5 * 60 * 1000))) {
            pssLastFetchTime = Date.now();

            fetchStoreData(pssUrl, shop_domain)
                .then(data => {
                    storeList = data.data.places;

                    if (undefined === defaultMapPosition) {
                        defaultMapPosition = new google.maps.LatLng(initMapCoordinatesLat, initMapCoordinatesLng);
                    }

                    if (undefined !== pssCluster) {
                        pssCluster.setMap(null);
                        mapMarkers = [];
                    }

                    if (document.querySelectorAll('#storeFilterModal input[type="checkbox"]').length > 0) {
                        pssResetFilterCheckbox();
                    }

                    if (0 === document.querySelectorAll('[data-remodal-id=stores-modal]').length) {
                        $('body').prepend(pssModal('stores-modal'));
                        const container = document.querySelector('[data-remodal-id=stores-modal] .stores-remodal__container');
                        container.innerHTML = pssContent();
                        pssInitMap()
                    }

                    pssModalOpen();
                    updateUIforStoreList(storeList);
                    if (pssEventListener === null) {
                        pssEventListeners();
                    }
                })
                .catch(error => {
                    console.error('There has been a problem with your fetch operation:', error);
                });
        } else {
            pssModalOpen();
        }
    });
}

const pssProductSelectListener = () => {
    pssMinictWrapper.addEventListener('click', function (event) {
        let target = event.target;

        if (target.tagName === 'LI' && target.classList.contains('selected')) {
            const selectedValue = target.getAttribute('data-value');
            const productSelect = document.getElementById('productSelect');
            const productOptions = Array.from(productSelect.options); // Convert to array

            productOptions.forEach(option => {
                if (option.value === selectedValue) {
                    pssStoreParams.product_sku = option.getAttribute('data-sku');
                    storeList = [];

                    // We update the value of pssFavoriteStoreCookie so that if you have chosen a new favorite store, we do not request the wrong one
                    pssFavoriteStoreCookie = Cookies.get('__btu_favorite_store');

                    // Delete old searchParams
                    pssUrl.searchParams.delete('product_sku');

                    // Register new searchParams
                    Object.keys(pssStoreParams).forEach(key => pssUrl.searchParams.append(key, pssStoreParams[key]));

                    if (pssFavoriteStoreCookie) {
                        fetchStoreData(pssUrl, shop_domain)
                            .then(data => {
                                const filteredPlaces = data.data.places.filter(place => place.place_id === pssFavoriteStoreCookie);
                                console.log(filteredPlaces)
                                pssFavoriteStore(filteredPlaces[0]);
                                document.getElementById('storeStockWrapper').removeAttribute('style');
                            })
                            .catch(error => {
                                console.error('There has been a problem with your fetch operation:', error);
                            });
                    } else {
                        document.getElementById('storeStockWrapper').removeAttribute('style');
                    }

                    return; // Exit forEach loop
                }
            });
        }
    });
}

const fetchStoreData = async (pssUrl, shop_domain) => {
    const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Original-Domain': shop_domain
        }
    };

    try {
        const response = await fetch(pssUrl, options);

        if (!response.ok) {
            throw new Error('Network response was not ok: ' + response.status);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        window.Sentry && Sentry.captureMessage('Bolti készlet lekérés sikertelen', {
            level: 'error',
            tags: { component: 'store-stock' },
            extra: { error: String(error), product_sku: pssStoreParams.product_sku }
        });
        throw error;
    }
}

const doTextSearch = function () {
    const pssSearchValue = document.getElementById('shop_search').value;
    updateUIforStoreList(storeList, pssSearchValue, false, true);
}

const pssEventListeners = function () {
    // Attach keyup event listener to #shop_search element
    document.getElementById('shop_search').addEventListener('keyup', function (e) {
        // Check if the pressed key is 'Enter'
        if (e.key === 'Enter') {
            doTextSearch();
        }
    });

    // Attach click event listener to #do_store_search element
    document.getElementById('do_store_search').addEventListener('click', function () {
        doTextSearch();
    });

    document.getElementById('store_filter').addEventListener('click', function () {
        if (0 === document.querySelectorAll('#storeFilterModal').length) {
            $('body').prepend(pssFilterModal());

            document.querySelector('#storeFilterModal #modal-header-close').addEventListener('click', function () {
                document.getElementById("storeFilterModal").classList.remove('show');
            });

            document.querySelector('#storeFilterModal #filterReset').addEventListener('click', function () {
                pssResetFilterCheckbox();
                document.getElementById("storeFilterModal").classList.remove('show');
                updateUIforStoreList(storeList, false, true, true);
            });

            document.querySelector('#storeFilterModal #isOpenNow').addEventListener('change', function (event) {
                updateStoreFilterCount();
            });

            document.querySelector('#storeFilterModal #isStock').addEventListener('change', function (event) {
                updateStoreFilterCount();
            });

            document.querySelector('#storeFilterModal #submitStoreFilter').addEventListener('click', function () {
                let filteredStoreList = storeList;
                if (document.querySelector('#isOpenNow').checked) {
                    filteredStoreList = isOpenFilteredStoreList(filteredStoreList);
                }
                if (document.querySelector('#isStock').checked) {
                    filteredStoreList = isStockFilteredStoreList(filteredStoreList);
                }
                updateUIforStoreList(filteredStoreList, false, true, true);
                document.getElementById("storeFilterModal").classList.remove('show');
            });
        }

        document.getElementById("storeFilterModal").classList.add('show');
    });

    pssEventListener = true;
}

const isOpenFilteredStoreList = function (data) {
    return data.filter(store => store.isOpenNow === true);
};

const isStockFilteredStoreList = function (data) {
    return data.filter(store => store.stock_status !== 'no-stock');
};

const pssResetFilterCheckbox = function () {
    const storeFilterCheckboxes = document.querySelectorAll('#storeFilterModal input[type="checkbox"]');

    storeFilterCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
    });
    document.querySelector('#storeFilterModal #submitStoreFilter span').textContent = ` `;
}

function updateStoreFilterCount() {
    let filteredCount = storeList.length;
    if (document.querySelector('#isOpenNow').checked) {
        filteredCount = isOpenFilteredStoreList(storeList).length;
    }
    if (document.querySelector('#isStock').checked) {
        filteredCount = isStockFilteredStoreList(storeList).length;
    }
    document.querySelector('#storeFilterModal #submitStoreFilter span').textContent = `(${filteredCount})`;
}

const updateUIforStoreList = function (data, pssLastSearchValue = false, doNotMoveMap = true, resetMarkers = false) {
    if (data && Array.isArray(data)) {
        if (resetMarkers) {
            map.setCenter(defaultMapPosition);
            map.setZoom(defaultMapZoom);
            pssCluster.setMap(null);
            mapMarkers = [];
        }

        // Sort the list of stores based on pssLastSearchValue
        if (pssLastSearchValue) {
            data.sort((a, b) => {
                function sortSearchMatch(searchValue, address, title, exactSearch = true) {
                    const exactRegExp = new RegExp("\\b" + searchValue + "\\b", "gi");
                    const partialRegExp = new RegExp(searchValue.toLowerCase(), "g");
                    const regExp = exactSearch ? exactRegExp : partialRegExp;
                    return (address.toLowerCase().match(regExp) || []).length + (title.toLowerCase().match(regExp) || []).length;
                }

                const matchesA = sortSearchMatch(pssLastSearchValue, a.data[0].formatted_address, a.title);
                const matchesB = sortSearchMatch(pssLastSearchValue, b.data[0].formatted_address, b.title);

                if (matchesA === 0 && matchesB === 0) {
                    const partialMatchesA = sortSearchMatch(pssLastSearchValue, a.data[0].formatted_address, a.title, false);
                    const partialMatchesB = sortSearchMatch(pssLastSearchValue, b.data[0].formatted_address, b.title, false);
                    return partialMatchesB - partialMatchesA;
                }

                return matchesB - matchesA;
            });
        }

        const markers = data.map((place, index) => {
            const position = {
                lat: place.data[0].geometry.location.lat,
                lng: place.data[0].geometry.location.lng
            };

            let label = {
                className: 'map-marker',
                // Google recommends setting these here, not in css:
                color: 'white',
                fontSize: '12px',
                fontWeight: 'normal',
                fontFamily: 'Roboto, sans-serif',
            }
            label.text = place.stock_status !== 'no-stock' ? " " : " ";
            const markerIcon = place.stock_status !== 'no-stock' ? "//baotechusa.com/cdn/shop/t/7/assets/map-marker-green.png?v=160520596525403895351745848128" : "//baotechusa.com/cdn/shop/t/7/assets/map-marker-red.png?v=149128251366119657101745848131";
            const gMarker = new google.maps.Marker({
                position,
                map,
                title: place.title,
                icon: markerIcon,
                label: label,
            });

            mapMarkers[index] = gMarker;
            storeList[index].index = index;

            gMarker.addListener("click", () => {
                infowindow.setContent(place.title + ", " + position.lat + ", " + position.lng);
            });

            google.maps.event.addListener(gMarker, 'click', (function (gMarker, index) {
                return function () {
                    //console.log(locations[index]);
                    openCardByIndex(index);
                    let infoWindowContent = '';
                    smoothPanTo(mapMarkers[index].position, mapMarkers[index], infoWindowContent, true, true);
                }
            })(gMarker, index));
            return gMarker;
        });

        const renderer = {
            render({count, position}, stats) {
                const svg = window.btoa(`
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="24" cy="24" r="24" fill="${clothingProduct ? '#0057FF' : '#1BABF9'}"/>
                                            </svg>
                                            `);
                return new google.maps.Marker({
                    position,
                    icon: {
                        url: `data:image/svg+xml;base64,${svg}`,
                        scaledSize: new google.maps.Size(40, 40),
                    },
                    label: {
                        text: String(count),
                        color: "rgba(255,255,255,0.9)",
                        fontSize: "12px",
                    },
                    title: ``,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                });
            }
        }

        //const algorithm = new markerClusterer.GridAlgorithm({gridSize: 90, maxZoom: 11});
        const algorithm = new markerClusterer.SuperClusterAlgorithm({maxZoom: 11, radius: 120});
        const config = {map, markers, algorithm, renderer};

        pssCluster = new markerClusterer.MarkerClusterer(config);
    } else {
        console.error("No places found!");
    }

    if (!doNotMoveMap) {
        let storePosition = new google.maps.LatLng(data[0].data[0].geometry.location.lat, data[0].data[0].geometry.location.lng);
        smoothPanTo(storePosition);
    }

    // Update list
    //=============
    storeListElement = document.querySelector('#store-list');
    storeListContainer = document.querySelector('#search-ui .store-list-container');
    storeListElement.innerHTML = '';

    const storeFragment = document.createDocumentFragment();

    if (data.length === 0) {
        const pssNoResult = document.createElement('article');
        pssNoResult.classList.add('store-card', 'store-card--no-result');
        pssNoResult.innerHTML = pssStoreNoResults();
        storeFragment.appendChild(pssNoResult)

        storeListElement.appendChild(storeFragment);
    } else {
        data.forEach(function (item, index) {
            const formattedOpeningHours = pssFormatOpeningHours(item.data[0].current_opening_hours);
            const todayOpeningHours = formattedOpeningHours.filter(day => day.day === pssTodayIndex);

            let openTime = '';
            let closeTime = '';
            let isOpenNow = false;

            if (todayOpeningHours.length > 0) {
                const currentTimeIndex = todayOpeningHours.findIndex(slot => pssCurrentTime < slot.closeTime);
                if (currentTimeIndex !== -1) {
                    openTime = todayOpeningHours[currentTimeIndex].openTime;
                    closeTime = todayOpeningHours[currentTimeIndex].closeTime;
                }

                isOpenNow = currentTimeIndex !== -1;
            }

            item.openTime = openTime;
            item.closeTime = closeTime;
            item.isOpenNow = isOpenNow;

            const pssCard = document.createElement('article');
            pssCard.classList.add('store-card', 'closed');
            pssCard.setAttribute('data-index', index);
            pssCard.innerHTML = pssStoreCard(item);
            storeFragment.appendChild(pssCard)
        });

        storeListElement.appendChild(storeFragment);
    }
    //console.log(storeList)

    if (pssLastSearchValue) {
        document.querySelector('.store-list-container').scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    document.querySelectorAll('.link.open').forEach(function (link) {
        link.addEventListener('click', function () {
            openCloseOpenTime(this)
        });
    });

    // Function to attach event listener and prevent event propagation
    let pssAttachClickListener = function (selector, callback) {
        let elements = document.querySelectorAll(selector);
        elements.forEach(function (element) {
            element.addEventListener('click', function (e) {
                e.stopPropagation();
                callback(this);
            });
        });
    }

    // Attach click event listener to elements with class 'pss_favorite_store'
    pssAttachClickListener('.pss_favorite_store', function (element) {
        const filteredPlaces = storeList.filter(place => place.place_id === element.dataset.place_id);
        pssFavoriteStore(filteredPlaces[0]);
        pssModalClose();
        Cookies.set('__btu_favorite_store', element.dataset.place_id);
    });

    // Attach click event listener to elements with class 'pss_stop_prop_click'
    pssAttachClickListener('.pss_stop_prop_click', function (element) {
        // Do nothing, just prevent event from bubbling up the DOM tree
    });

    // Attach click event listener to elements with class 'pss_open'
    pssAttachClickListener('.pss_open', function (element) {
        openCard(element);
    });

    // Attach click event listener to elements with class 'pss_close'
    pssAttachClickListener('.pss_close', function (element) {
        openCloseOpenTime(element.parentElement.parentElement.querySelector('.store-card__body'), false)
        closeCard(element);
    });
}

const openCloseOpenTime = function (that, thisOpen = true) {
    const storeCard = that.closest('.store-card__body').parentNode;
    const openTime = that.closest('.store-card__body').querySelector('.link.open');
    const openFull = that.closest('.store-card__body').querySelector('.link.open-full');

    if (storeCard && openTime && openFull) {
        const isOpen = openFull.style.display === 'none';
        if (isOpen && thisOpen) {
            openTime.classList.remove('closed');
            openTime.classList.add('opened');
            storeCard.classList.add('opened-scroll');
            openFull.removeAttribute('style');
        } else {
            openTime.classList.remove('opened');
            openTime.classList.add('closed');
            storeCard.classList.remove('opened-scroll');
            openFull.style.display = 'none';
        }
    }
}

const pssShowStoreOnMap = function (index) {
    //console.log('clicked '+index, this);
    let infoWindowContent = '';
    smoothPanTo(mapMarkers[index].position, mapMarkers[index], infoWindowContent);
}

const openCardByIndex = async function (index) {
    let pssCard = document.querySelector(`#store-list [data-index='${index}']`);
    document.querySelector('.store-list-container').scrollTo({
        top: pssCard.offsetTop,
        behavior: 'smooth'
    });
    await sleep(500);
    openCard(pssCard, false);
}

const openCard = function (that, scroll = true) {
    closeAllCards();

    storeListContainer.classList.add("highlight");

    let pssCard = that.closest('.store-card');

    if (scroll) {
        document.querySelector('.store-list-container').scrollTo({
            top: pssCard.offsetTop,
            behavior: 'smooth'
        });
    }

    pssShowStoreOnMap(pssCard.getAttribute('data-index'));
    pssCard.classList.remove('closed');
    pssCard.classList.add('opened');

    let linksAndButtons = pssCard.querySelectorAll('div.links, div.buttons');
    linksAndButtons.forEach(function (element) {
        element.style.display = 'flex';
    });
}

const closeCard = function (that) {
    let pssCard = that.closest('.store-card');
    zoomOutOnMap();
    pssCard.classList.remove('opened');
    pssCard.classList.add('closed');

    storeListContainer.classList.remove("highlight");

    let linksAndButtons = pssCard.querySelectorAll('div.links, div.buttons');
    linksAndButtons.forEach(function (element) {
        element.style.display = 'none'; // Assuming slideUp() just hides the element
    });
}

const closeAllCards = function () {
    // Remove highlight class from storeListContainer
    storeListContainer.classList.remove("highlight");

    // Get all store-card elements with class 'opened'
    let pssCards = document.querySelectorAll('.store-card.opened');

    // Iterate through each card element
    pssCards.forEach(function (card) {
        // Remove 'opened' class and add 'closed' class
        card.classList.remove('opened');
        card.classList.add('closed');

        // Select div elements with class 'links' and 'buttons' inside the current card
        let linksAndButtons = card.querySelectorAll('div.links, div.buttons');

        // Iterate through selected div elements and slide them up
        linksAndButtons.forEach(function (element) {
            element.style.display = 'none'; // You can adjust the sliding animation as needed
        });
    });
}

const zoomOutOnMap = function () {
    infowindow.close();
    map.setZoom(map.getZoom() - 1);
}

const smoothPanTo = function (latlng, targetMarker, infoWindowContent, noZoomOut = false, noZoomIn = false) {

    let dist = google.maps.geometry.spherical.computeDistanceBetween(map.getCenter(), latlng);

    infowindow.close();
    // If distance is small (<100m) we let the marker auto-pan to deal with it
    if (dist < 100) {
        if (targetMarker != null) {
            if (enableInfoWindows && infoWindowContent != null) {
                infowindow.setContent(infoWindowContent);
                infowindow.open(map, targetMarker);
            }
        }
        map.setZoom(map.getZoom() + 0.5);
        return;
    }

    /**
     * Controls the base value for zoom calculation.
     * This number has equal effect for far and close points.
     * The smaller the number, map zooms out less during panning.
     * If this number is increased the one or both of the others should be increased as well.
     * @type {number}
     */
    let baseZoom = 17;

    /**
     * Controls how close we keep our zoom during panning.
     * This number has more pronounced effect for points close to each other.
     * The smaller the number, map zooms out more during panning.
     * Good values are in the -1 to 3 range.
     * For every 1 increase of this number increase `zoomPanFactor` with about 0.1 to 0.25.
     * @type {number}
     */
    let zoomPanOffset = 2;

    /**
     * Controls how close we keep our zoom during panning.
     * This number has more pronounced effect for points far from each other.
     * The smaller the number, map zooms out less during panning.
     * Good values are in the 1 to 1.8 range.
     * For every 0.1 increase of this number increase `zoomPanOffset` with about 0.5 to 1.5.
     * @type {number}
     */
    let zoomPanFactor = 1.75;

    /**
     * Controls how close the map zooms at the final position after the panning.
     * The higher the number, the closer the zoom will be.
     * Good values are between 1 and 5.
     * Set to 0 to not zoom in after panning.
     * If the number is too big, Maps may not animate the zoom, so avoid really high numbers!
     * @type {number}
     */
    let zoomFinalOffset = 2.1;

    // Main animation loop:
    let step = 0;
    let panningZoom;
    let lastZoom = 0;
    let mapEventListener = google.maps.event.addListener(map, 'idle', async function () {
        //console.log('Animate loop triggered. Current step value is: ' + step);

        if (noZoomOut) {
            step = Math.max(step, 11);
        }

        // Zoom out
        // This is tricky, because sometimes the Map refuses to change the zoom, so
        // we must limit the number of attempts
        if (step < 11) {
            // console.log('step ' + step);

            // Calculate our zoom during the panning based on distance.
            panningZoom = baseZoom + zoomPanFactor * (Math.log10(1 / dist) + zoomPanOffset);

            // If the calculated panning zoom is higher than the current zoom, we should not change it
            if (panningZoom > map.getZoom()) {
                step = Math.max(step, 11); // max prevents going back to previous step on multiple calls
            }

            // Google Maps do not really respect zooms beyond the precision of
            else if (Math.abs(map.getZoom() - panningZoom) < 0.1) {
                step = Math.max(step, 11); // max prevents going back to previous step on multiple calls
            }

            // Map refuses to change the zoom any more, so we can proceed
            else if (lastZoom === map.getZoom()) {
                step = Math.max(step, 11); // max prevents going back to previous step on multiple calls
            }

            // We only change zoom by 3 max at a time, because high changes cause jump and no animation
            else {
                let targetZoom = Math.max(panningZoom, map.getZoom() - 3);
                lastZoom = map.getZoom();
                //console.log( panningZoom, map.getZoom(), targetZoom );
                map.setZoom(Math.max(targetZoom, map.getZoom() - 3))
                step++
            }

        }

        // Pan
        if (step === 11) {
            if (targetMarker != null) {

            }
            //console.log('step ' + step);
            await sleep(250);
            map.panTo(latlng);
            step = Math.max(step, 12);
            if (noZoomIn) {
                step = Math.max(step, 13);
            }
            return;
        }

        // Zoom in
        else if (step === 12) {
            //console.log('step ' + step);
            if (!noZoomIn) {
                await sleep(330);
                map.setZoom(panningZoom + zoomFinalOffset);
            }
            step = Math.max(step, 13);
            return;
        }

        // Add new marker
        else if (step === 13) {
            //console.log('step ' + step);
            if (enableInfoWindows && targetMarker != null && infoWindowContent != null) {
                await sleep(100);
                infowindow.setContent(infoWindowContent);
                infowindow.open(map, targetMarker);
            }
            step = Math.max(step, 14);
        }

        // Finished
        if (step > 13) {
            //console.log('Animation finished. Current step is: ' + step);
            google.maps.event.removeListener(mapEventListener);
            document.dispatchEvent(eventSPTC);
        }
    });

    // Trigger the animation
    google.maps.event.trigger(map, 'idle');
}

const pssInitMap = async () => {
    map = new google.maps.Map(document.getElementById("map_canvas"), {
        zoom: defaultMapZoom,
        center: defaultMapPosition,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });
    infowindow = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: true,
    });
    resetMapView();
}

const resetMapView = function () {
};

const sleep = function (ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const pssFormatOpeningHours = function (openingHours) {
    let formattedHours = [];

    if (openingHours !== undefined && openingHours.periods && openingHours.periods.length > 0) {
        openingHours.periods.forEach(opening => {
            const day = opening.open.day;
            const openTime = pssFormatTime(opening.open.time);
            const closeTime = pssFormatTime(opening.close.time);
            formattedHours.push({day, openTime, closeTime});
        });
    }

    return formattedHours;
}

const pssFormatTime = function (time) {
    const formattedTime = time.substring(0, 2) + ':' + time.substring(2);
    return formattedTime;
}

const pssFavoriteStore = function (item) {
    let stockStatusText = '';
    if (item.stock_status === 'in-stock') {
        stockStatusText = clothingProduct ? `<span class="in-stock">Auf Lager im ausgewählten Geschäft</span>` : `Der von dir gewählte Shop: <span class="in-stock">Verfügbar</span>`;
    } else if (item.stock_status === 'last-in-stock') {
        stockStatusText = clothingProduct ? `<span class="in-stock">Letzter Artikel im ausgewählten Geschäft</span>` : `Der von dir gewählte Shop: <span class="in-stock">1 Stück verfügbar</span>`;
    } else {
        stockStatusText = clothingProduct ? `<span class="no-stock">Nicht auf Lager im ausgewählten Geschäft</span>` : `Der von dir gewählte Shop: <span class="no-stock">Nicht verfügbar</span>`;
    }

    document.getElementById('storeStockStock').innerHTML = stockStatusText;
    document.getElementById('storeStockName').textContent = item.title;
    document.getElementById('storeStockButton').classList.add('store-stock__favorite');
    document.getElementById('storeStockButton').textContent = 'Wähle ein anderes Geschäft';
    document.getElementById('storeStockWrapper').classList.add('store-stock-favorite');
}

const pssModalOpen = () => {
    const options = {modifier: "biotech_modal-wrapper--stores"}
    const inst = $('[data-remodal-id=stores-modal]').remodal(options);
    inst.open();
}

const pssModalClose = () => {
    const options = {modifier: "biotech_modal-wrapper--stores"}
    const inst = $('[data-remodal-id=stores-modal]').remodal(options);
    inst.close();
}

const pssModal = (modal_id) => `
    <div class="biotech_modal biotech_modal--stores overlay-popup popup-stack" data-remodal-id="${modal_id}">
        <div class="stores-remodal__container"></div>
    </div>
`;

const pssContent = () => `
    <div class="${clothingProduct ? 'stores-remodal__header cl-stores-remodal__header' : 'stores-remodal__header'}">
        <h2 class="${clothingProduct ? 'stores-remodal__header--title cl-stores-remodal__header--title' : 'stores-remodal__header--title'}">
            Ein Geschäft finden
        </h2>
        <button data-remodal-action="close" class="stores-close-button"></button>
    </div>
    <div class="stores-remodal__content">
        <div id="stores-remodal-content-inner" class="stores-remodal__content-inner">
            <div class="grid">
                <section id="search-ui" class="grid__item large--one-third">
                    <div class="store-list-container">
                        <div id="store-list" ${clothingProduct ? 'class="cl-store-list"' : ''}><!-- pos rel: jq -->
                            <!-- Hits come here -->
                        </div>
                    </div>
                </section>

                <section id="map" class="grid__item large--two-thirds">
                    <div class="widget">
                        <div class="${clothingProduct ? 'search-controls cl-search-controls' : 'search-controls'}">
                            <div class="search-input-wrapper">
                                <input type="text" name="shop_search" id="shop_search" placeholder="Ein Geschäft finden...">
                                <div class="icon icon-24 input-icon hover icon-search" id="do_store_search">
                                    <div class="img stroke">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.6426 12.6436L18.9992 19.0002" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M8.125 14.5C11.6458 14.5 14.5 11.6458 14.5 8.125C14.5 4.60418 11.6458 1.75 8.125 1.75C4.60418 1.75 1.75 4.60418 1.75 8.125C1.75 11.6458 4.60418 14.5 8.125 14.5Z" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <button class="filter-wrapper" id="store_filter">
                                <div class="icon icon-24 input-icon hover icon-filter">
                                    <div class="img stroke">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4 12H20H4Z" fill="#798F9C"/>
                                            <path d="M4 12H20" stroke="#798F9C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M4 7H20H4Z" fill="#798F9C"/>
                                            <path d="M4 7H20" stroke="#798F9C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M4 17H20H4Z" fill="#798F9C"/>
                                            <path d="M4 17H20" stroke="#798F9C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <circle cx="6" cy="7" r="1.5" fill="#798F9C" stroke="#798F9C"/>
                                            <circle cx="12" cy="12" r="1.5" fill="#798F9C" stroke="#798F9C"/>
                                            <circle cx="18" cy="17" r="1.5" fill="#798F9C" stroke="#798F9C"/>
                                        </svg>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div id="map_canvas" class="map_canvas"></div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="stores-stores__footer"></div>
`;

const pssStoreNoResults = () => `
    <div class="store-card__body">
        <header>
            <h2 class="title">Es gibt kein Ergebnis!</h2>
        </header>
        <p>Wir haben kein Geschäft gefunden, das den Suchkriterien entspricht.</p>
    </div>
`;

const pssStoreCard = (item) => {
    let pssTodayStatusHTML = '<span>Geschlossen</span>'; // Default state: closed

    if (item.isOpenNow) {
        let pssOpenUntil = 'Geöffnet bis !!#closeTime#!!';
        pssOpenUntil = pssOpenUntil.replace("!!#closeTime#!!", item.closeTime);
        pssTodayStatusHTML = `<span>${item.isOpenNow ? pssOpenUntil : ''}</span>`;
    }

    const daysOfWeek = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
    let periodsHTML = '';

    if (undefined !== item.data[0].opening_hours && undefined !== item.data[0].opening_hours.periods) {
        item.data[0].opening_hours.periods.forEach(period => {
            // Get the index of the day from the period objects
            const dayIndex = period.open.day;
            // Get the corresponding day name from the daysOfWeek array
            const dayName = daysOfWeek[dayIndex];

            // Convert opening and closing times using the pssFormatTime function
            const openingTime = pssFormatTime(period.open.time);
            const closingTime = pssFormatTime(period.close.time);

            // Display the day name along with the formatted opening and closing times
            periodsHTML += `
                <div class="flex-row ${pssTodayIndex === dayIndex ? 'today' : ''} ${dayIndex === 0 ? 'order-last' : 'order-' + dayIndex}">
                    <div class="flex-col day">${dayName}:</div>
                    <div class="flex-col time">${openingTime} - ${closingTime}</div>
                </div>
            `;
        });
    } else {
        periodsHTML += `<div>Dauerhaft geschlossen</div>`;
    }

    let stockStatusText = '';
    if (item.stock_status === 'in-stock') {
        stockStatusText = `Verfügbar`;
    } else if (item.stock_status === 'last-in-stock') {
        stockStatusText = `Letztes Exemplar`;
    } else {
        stockStatusText = `Nicht verfügbar`;
    }

    return `
        <div class="${clothingProduct ? 'close-control cl-close-control' : 'close-control'}">
            <button class="pss_close">Ausgewähltes Geschäft</button>
        </div>
        <div class="${clothingProduct ? 'store-card__body cl-store-card__body' : 'store-card__body'}">
            <header>
                <h2 class="title">${item.title}</h2>
            </header>
            <div class="address address-close">${item.data[0].formatted_address}</div>
            <div class="stock ${item.stock_status !== 'no-stock' ? "in-stock" : "no-stock"} p2 regular">${stockStatusText}</div>
            <div class="open open-close">
                ${pssTodayStatusHTML}
            </div>
            <div class="row links" style="display: none;" class="pss_stop_prop_click">
                <div class="link address">${item.data[0].formatted_address}</div>
                <div class="link open closed">
                    ${item.isOpenNow ? `
                        <span class="open--green">Geöffnet</span> Schließt: ${item.closeTime}</span>
                    ` : `<span class="open--red">Geschlossen</span>`}
                </div>
                <div class="link open-full" style="display:none">
                    ${periodsHTML}
                </div>
                <div class="link flex-row ">
                    ${item.data[0].international_phone_number ? `
                    <div class="phone">
                        <a href="tel:${item.data[0].international_phone_number}" class="pss_stop_prop_click">${item.data[0].international_phone_number}</a>
                    </div>` : ''}
                    ${item.data[0].website ? `
                    <div class="website">
                        <a href="${item.data[0].website}" target="_blank" class="pss_stop_prop_click">
                            Website
                        </a>
                    </div>` : ''}
                </div>
            </div>
            <div class="control">
                <button class="button--outlined details pss_open">Geschäftsdetails</button>
                <a href="https://maps.google.hu/maps/dir/?api=1&destination=${item.data[0].name} ${item.data[0].formatted_address}&destination_place_id=${item.data[0].place_id}" target="_blank" class="button--outlined route-planner pss_stop_prop_click">
                    Eine Route planen
                </a>
                <button data-place_id="${item.place_id}" class="button pss_favorite_store"> Geschäft speichern</button>
            </div>
        </div>
    `;
};

const pssFilterModal = () => `
                <div class="modal ${clothingProduct ? 'store-filter-modal cl-store-filter-modal' : 'store-filter-modal'} show" id="storeFilterModal" tabindex="-1" role="dialog"
                 aria-labelledby="storeFilterModalLabel" aria-modal="true">
                    <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-wrapper">
                            <div class="modal-header">
                                ${clothingProduct ? `
                                <h3 class="modal-header__title">
                                    Filter
                                </h3>` :
                                `<button type="button" id="filterReset" class="filter-reset">
                                    Alle Filter löschen
                                </button>`}
                                <button type="button" id="modal-header-close" class="modal-close" data-dismiss="modal" aria-label="Close">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_10020_180593)">
                                        <path d="M32 32L16.0007 16M32 16.0015L16 32L32 16.0015Z" stroke="#798F9C" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_10020_180593">
                                        <rect width="24" height="24" fill="white" transform="translate(12 12)"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div id="modalFilters" class="modal-filters">

                                </div>
                                <div class="modal-cards">
                                    <div class="modal-card">
                                        <div class="modal-card__header">
                                            <h3 class="card__title">Öffnungszeiten</h3>
                                        </div>
                                        <div class="modal-card__body">
                                            <input type="checkbox" id="isOpenNow" name="isOpenNow" />
                                            <label for="isOpenNow">Derzeit geöffnet</label>
                                        </div>
                                    </div>
                                    <div class="modal-card">
                                        <div class="modal-card__header">
                                            <h3 class="card__title">Vorrat</h3>
                                        </div>
                                        <div class="modal-card__body">
                                            <input type="checkbox" id="isStock" name="isStock" />
                                            <label for="isStock">Auf Lager</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="submit-container">
                                    <button id="submitStoreFilter" class="button modal-button" type="button">
                                        Geschäfte anzeigen <span></span>
                                    </button>
                                </div>
                                ${clothingProduct ? `
                                <div class="filter-reset-container">
                                    <button type="button" id="filterReset" class="filter-reset">
                                        Filter zurücksetzen
                                    </button>
                                </div>` : ''}
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            `
